module.exports = __webpack_public_path__ + "static/media/6.0a9b39aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/slides/6.jpg
// module id = 783
// module chunks = 0